export const validateFields = async values => {
  let errors = {};

  /*** Name Tab */
  if (!values.regid) {
    errors.regid = 'Required';
    errors.notifyFormErrors = 'Reg Id Required';
    throw errors;
  } else if (!values.fname) {
    errors.fname = 'Required';
    errors.notifyFormErrors = 'First Name Required';
    throw errors;
  } else if (!values.lname) {
    errors.lname = 'Required';
    errors.notifyFormErrors = 'Last Name Required';
    throw errors;

  /*** Programs */
  } else if (values.program === '0') {
    errors.program = 'Required';
    errors.notifyFormErrors = 'Programs Tab - Program Assigned Tab - No Program Selected';
    throw errors;

  /*** Dates Tab */
  } else if (!values.referralrequestedadmissiondate) {
    errors.referralrequestedadmissiondate = 'Required';
    errors.notifyFormErrors = 'Requested Admission Date Required';
    throw errors;

  /*** All Program Details */
  /*** Referral Conditions */
  } else if (
    (values.referralhomelessna === 0 || values.referralhomelessna === false ) 
    &&
    (values.referralhomelesshistory === false || values.referralhomelesshistory === 0) 
    && 
    (values.referralhomelesscurrent === false || values.referralhomelesscurrent === 0)
    )  {
      errors.referralhomelessna = 'Required';
      errors.notifyFormErrors = 'All Program Details Tab - Referral Conditions Tab - Referral Homeless in past 12 months - Required';
      throw errors;
  } else if (
    (values.referralmentalhealthissuesna === 0 || values.referralmentalhealthissuesna === false ) 
    &&
    (values.referralmentalhealthissueshistory === false || values.referralmentalhealthissueshistory === 0) 
    && 
    (values.referralmentalhealthissuescurrent === false || values.referralmentalhealthissuescurrent === 0)
    )  {
      errors.referralmentalhealthissuesna = 'Required';
      errors.notifyFormErrors = 'All Program Details Tab - Referral Conditions Tab - Behavioral / Mental Health Issues - Required';
      throw errors;
  } else if (
    (values.referralsubstanceusedisorderissuesna === 0 || values.referralsubstanceusedisorderissuesna === false ) 
    &&
    (values.referralsubstanceusedisorderissueshistory === false || values.referralsubstanceusedisorderissueshistory === 0) 
    && 
    (values.referralsubstanceusedisorderissuescurrent === false || values.referralsubstanceusedisorderissuescurrent === 0)
    )  {
      errors.referralsubstanceusedisorderissuesna = 'Required';
      errors.notifyFormErrors = 'All Program Details Tab - Referral Conditions Tab - Substance Use Disorder - Required';
      throw errors;
  } else if (
    (values.referralcooccurringna === 0 || values.referralcooccurringna === false ) 
    &&
    (values.referralcooccurringhistory === false || values.referralcooccurringhistory === 0) 
    && 
    (values.referralcooccurringcurrent === false || values.referralcooccurringcurrent === 0)
    )  {
      errors.referralcooccurringna = 'Required';
      errors.notifyFormErrors = 'All Program Details Tab - Referral Conditions Tab - Co-occurring Disorders - Required';
      throw errors;
  } else if (
    (values.referralemployedduringpastna === 0 || values.referralemployedduringpastna === false ) 
    &&
    (values.referralemployedduringpasthistory === false || values.referralemployedduringpasthistory === 0) 
    && 
    (values.referralemployedduringpastcurrent === false || values.referralemployedduringpastcurrent === 0)
    )  {
      errors.referralemployedduringpastna = 'Required';
      errors.notifyFormErrors = 'All Program Details Tab - Referral Conditions Tab - Employed in past 12 months - Required';
      throw errors;

  /*** Outcome */
  } else if (values.referraloutcome === '2' && !values.referraloutcomecomments) {
    errors.referraloutcomecomments = 'Required - Explain the reason or basis for the hold.  Please be aware of HIPAA laws and concerns. Enter only what is required, nothing more that is not permitted by law.';
    errors.notifyFormErrors = 'Outcome Tab - Referral Outcome - Comments Required';
      throw errors;
  } else if (values.referraloutcome === '6' && !values.referraloutcomecomments) {
    errors.referraloutcomecomments = 'Required - Explain the reason or basis for the denial.  Please be aware of HIPAA laws and concerns. Enter only what is required, nothing more that is not permitted by law.';
    errors.notifyFormErrors = 'Outcome Tab - Referral Outcome - Comments Required';
    throw errors;
  } else if (values.referraloutcome === '1'  && ( !values.referralapproveddate) ) {
    errors.referralapproveddate = 'Required - Before accepting and pending Referral Approved Date must be entered.';
    errors.notifyFormErrors = 'Dates Tab - Referral Approved Date Required';
    throw errors;
  } else if (values.referraloutcome === '3'  && ( !values.referralreceiveddate || !values.referralapproveddate || !values.referralrequestedadmissiondate || !values.referralapprovedadmissiondate || !values.referralprojectedreleasedate) ) {
    errors.referralreceiveddate = 'Required - Before accepting as as client all dates must be entered on the dates tab.';
    errors.referralapproveddate = 'Required - Before accepting as as client all dates must be entered on the dates tab.';
    errors.referralrequestedadmissiondate = 'Required - Before accepting as as client all dates must be entered on the dates tab.';
    errors.referralapprovedadmissiondate = 'Required - Before accepting as as client all dates must be entered on the dates tab.';
    errors.referralprojectedreleasedate = 'Required - Before accepting as as client all dates must be entered on the dates tab.';
    errors.notifyFormErrors = 'Dates Tab - Required Dates Missing';
    throw errors;

  }
  return errors;
};
export default validateFields;














/*** validate examples keep these */
                                                                            // } else if (values.program === 1 || values.program === '1') {
                                                                            // } else if (values.program === '1') {
                                                                            // } else if (values.program === 1) {
                                                                              // if (!values.bopsupervisingofficercomments && values.bopsupervisingofficercomments !== null) {


                                                                          // } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.fname)) {
                                                                          //   errors.fname = 'Invalid Characters in First Name'
                                                                          //   errors.notifyFormErrors = 'Invalid Characters in First Name';
                                                                          //   throw errors;


                                                                          // const requiredFields = [
                                                                          //   'lname',
                                                                          //   'lname',
                                                                          //   'favoriteColor',
                                                                          //   'notes'
                                                                          // ]
                                                                          // requiredFields.forEach(field => {
                                                                          //   if (!values[field]) {
                                                                          //     errors[field] = 'Required'
                                                                          //   }
                                                                          // })
                                                                          // if (
                                                                          //   values.lname &&
                                                                          //   !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.lname)
                                                                          // ) {
                                                                          //   errors.lname = 'Invalid Last Name'
                                                                          // }


                                                                          // // if (!values.lname) return;
                                                                          // // const data = await axios.get(`/validate/${values.lname}`);
                                                                          // if (!values.lname) {
                                                                          //   // return { lname: `lname ${values.lname} is already taken.`};
                                                                          //   errors = {lname: '00000000    Wrong length. Expects (4-32 chars).'};
                                                                          //   throw errors; // Error: asyncValidate function passed to reduxForm must return a promise
                                                                          // }


                                                                          // // if (!values.fname) {
                                                                          //   if (['aaa', 'bbb'].includes(values.fname)) {
                                                                          //     console.log('111-error here'    );
                                                                          //     // eslint-disable-next-line no-throw-literal
                                                                          //     // throw { fname: 'First Name already Exists' }
                                                                          //     errors = {fname: 'First Name already Exists'};
                                                                          //     // errors.fname = 'First Name already Exists'
                                                                          //     throw errors; // Error: asyncValidate function passed to reduxForm must return a promise
                                                                          //   }





//// OLD CODE REMOVED BUT MAY GET PUT BACK...



                                                                  // // } else if (!values.dob) {
                                                                  //   errors.dob = 'Required';
                                                                  //   errors.notifyFormErrors = 'Date of Birth Required';
                                                                  //   throw errors;

                                                                            /*** BOP RRC */
                                                                            //  // } else if (values.program === '1' && !values.bopsupervisingofficercomments ) {
                                                                            // } else if (values.program === 1 && !values.bopsupervisingofficercomments ) {
                                                                            //   errors.bopsupervisingofficercomments = 'Required';
                                                                            //   errors.notifyFormErrors = 'Programs Tab - BOP Officer Tab - BOP RRC - REQUIRES - BOP Supervising Officer Assigned - Details';
                                                                            //   throw errors;
                                                                            // // } else if (values.program === '1' && !values.bopinstitutioncomments ) {
                                                                            // } else if (values.program === 1 && !values.bopinstitutioncomments ) {
                                                                            //     errors.bopinstitutioncomments = 'Required';
                                                                            //     errors.notifyFormErrors = 'Programs Tab - BOP Institution Tab - BOP RRC - REQUIRES - BOP Institution Comments';
                                                                            //     throw errors;
                                                                            // // } else if (values.program === '1' && !values.bopgangaffiliationcomments ) {      
                                                                            // } else if (values.program === 1 && !values.bopgangaffiliationcomments ) {      
                                                                            //     errors.bopgangaffiliationcomments = 'Required';
                                                                            //     errors.notifyFormErrors = 'Programs Tab - BOP Gang Affiliation Tab - BOP RRC - REQUIRES - BOP Gang Affiliation Comments';
                                                                            //     throw errors;

                                                                            /*** OP Custs Psy */
                                                                            // // } else if (values.program === '4' && !values.opcusptspsyofficercomments ) {      
                                                                            // } else if (values.program === 4 && !values.opcusptspsyofficercomments ) {      
                                                                            //   errors.opcusptspsyofficercomments = 'Required';
                                                                            //   errors.notifyFormErrors = 'Programs Tab - OPC US PTS-Psy Officer Tab - OPC US PTS-Psy - REQUIRES - OPC US PTS-Psy Officer Assigned - Details';
                                                                            //   throw errors;


                                                                        // } else if (!values.referralprojectedreleasedate) {
                                                                        //   errors.referralprojectedreleasedate = 'Required';
                                                                        //   errors.notifyFormErrors = 'Projected Release Date';
                                                                        //   throw errors;
                                                                        // } else if (!values.referralapproveddate) {
                                                                        //   errors.referralapproveddate = 'Required';
                                                                        //   errors.notifyFormErrors = 'Referral Approved Date';
                                                                        //   throw errors;
                                                                        // } else if (!values.referralapprovedadmissiondate) {
                                                                        //   errors.referralapprovedadmissiondate = 'Required';
                                                                        //   errors.notifyFormErrors = 'Approved Admission Date';
                                                                        //   throw errors;


